<!-- Register route: path: '/org/:sub_level/:id/proface-wing-report', component: ProfaceWingReport -->
<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mal-text mt-1 custom-title">PROFACE COMMUNE</h3>
            <p class="text-center text-primary small mb-0 fw-semibold">PROFESSIONAL WING, WISDOM YOUTH</p>
            <p class="text-center text-muted small mb-0" v-if="breadcrumb">{{ breadcrumb }}</p>
        </div>
    </div>

    <div class="section text-center py-3" v-if="loading">
        <div class="spinner-border text-primary" role="status"></div>
    </div>

    <div class="section" v-if="!loading && reportList.length === 0">
        <h4 class="text-center text-primary mal-text">ഡാറ്റ ലഭ്യമല്ല</h4>
    </div>

    <!-- District rollup (state admin, level 1) -->
    <div class="section pb-2" v-if="!loading && reportList.length && canDrillDown">
        <div class="card pwr-card mt-1" v-for="row in reportList" :key="'d-' + row.id" @click="goDrillDown(row)">
            <div class="card-body py-3">
                <div class="d-flex justify-content-between align-items-center">
                    <strong class="text-primary fs-6">{{ row.name }}</strong>
                    <ion-icon name="chevron-forward-outline" class="text-primary"></ion-icon>
                </div>
                <div class="mt-2">
                    <small class="text-muted d-block">സമർപ്പിച്ചത്</small>
                    <span class="fw-semibold">{{ row.submitted_count }} / {{ row.zones_count }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Zone list (district or state-drilled-into-district, level 2) -->
    <div class="section pb-2" v-if="!loading && reportList.length && !canDrillDown">
        <div
            class="card pwr-card mt-1"
            v-for="row in reportList"
            :key="'z-' + row.id"
            :class="{ 'pwr-card-active': selectedZoneId === row.id }"
        >
            <div class="card-body py-2" @click="toggleZoneDetail(row)">
                <div class="d-flex justify-content-between align-items-start">
                    <div>
                        <strong class="text-primary">{{ row.name }}</strong>
                        <p class="text-danger small mb-0" v-if="!row.submitted">സമർപ്പിച്ചിട്ടില്ല</p>
                        <p class="text-muted small mb-0" v-else>
                            ചെയർമാൻ: {{ row.chairman_name }}
                        </p>
                    </div>
                    <ion-icon
                        v-if="row.submitted"
                        :name="selectedZoneId === row.id ? 'chevron-up-outline' : 'chevron-down-outline'"
                        class="text-primary mt-1"
                    ></ion-icon>
                </div>
            </div>

            <div class="pwr-detail-panel px-3 pb-3" v-if="selectedZoneId === row.id && row.submitted">
                <ul class="listview simple-listview flush pwr-detail-list">
                    <li v-for="field in fields" :key="field.key">
                        <span>{{ field.label }}</span>
                        <span class="text-primary fw-medium">{{ row[field.key] || '—' }}</span>
                    </li>
                    <li>
                        <span>സമർപ്പിച്ചത്</span>
                        <span class="text-primary fw-medium">{{ row.submitted_by_name || '—' }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
</template>

<script>
import UserService from "../services/user.service";
import AlertModel from "./layouts/AlertModel.vue";

const FIELDS = [
    { key: "chairman_name", label: "CHAIRMAN (NAME)" },
    { key: "chairman_number", label: "CHAIRMAN (NUMBER)" },
    { key: "convenor_name", label: "CONVENOR (NAME)" },
    { key: "convenor_number", label: "CONVENOR (NUMBER)" },
];

export default {
    name: "ProfaceWingReport",
    components: { AlertModel },
    data() {
        return {
            loading: true,
            alert_type: "",
            alert_message: "",
            reportList: [],
            canDrillDown: false,
            userLevel: 1,
            userLevelId: 0,
            selectedZoneId: null,
            breadcrumb: "",
            fields: FIELDS,
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
    },
    watch: {
        "$route.params"() {
            this.userLevel = parseInt(this.$route.params.sub_level) || 1;
            this.userLevelId = parseInt(this.$route.params.id) || 0;
            this.selectedZoneId = null;
            this.loadReport();
        },
    },
    mounted() {
        const level = parseInt(this.currentUser?.user_level, 10);
        if (!this.currentUser || level > 3) {
            this.alert_type = "Warning";
            this.alert_message = "District/State/Zone admin access only";
            this.$refs.alert_model?.openModel();
            return;
        }
        const ownLevelId = level === 3 ? this.currentUser.zone_id : level === 2 ? this.currentUser.district_id : 0;
        this.userLevel = parseInt(this.$route.params.sub_level) || level;
        this.userLevelId = parseInt(this.$route.params.id) || ownLevelId;
        this.loadReport();
    },
    methods: {
        goDrillDown(row) {
            this.$router.push("/org/2/" + row.id + "/proface-wing-report");
        },
        toggleZoneDetail(row) {
            if (!row.submitted) return;
            this.selectedZoneId = this.selectedZoneId === row.id ? null : row.id;
        },
        loadReport() {
            this.loading = true;
            UserService.authPostRequest("proface-wing/report", {
                user_level: this.userLevel,
                user_level_id: this.userLevelId,
            }).then((res) => {
                this.loading = false;
                if (res.data.status === "success") {
                    this.reportList = res.data.data.list || [];
                    this.canDrillDown = res.data.data.can_drill_down;
                    this.userLevel = res.data.data.user_level || this.userLevel;
                } else {
                    this.alert_type = "Warning";
                    this.alert_message = res.data.message || "ഡാറ്റ ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല";
                    this.$refs.alert_model?.openModel();
                }
            }).catch((err) => {
                this.loading = false;
                this.alert_type = "Error";
                this.alert_message = err.response?.data?.message || "ഡാറ്റ ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല";
                this.$refs.alert_model?.openModel();
            });
        },
    },
};
</script>

<style scoped>
.custom-title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #1a418c;
}

.pwr-card {
    border: none;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    overflow: hidden;
}

.pwr-card-active {
    box-shadow: 0 4px 14px rgba(26, 65, 140, 0.18);
}

.pwr-detail-list li {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 0;
    border-bottom: 1px solid #f0f2f5;
    font-size: 0.85rem;
}

.pwr-detail-list li:last-child {
    border-bottom: none;
}
</style>
